import React from "react";
import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  Grid,
  Paper,
} from "@mui/material";
import Heading from "../components/Heading";

const ContactUs = () => {
  return (
    <Box sx={{ py: 3 }}>
      <Container maxWidth="lg">
        <Paper
          elevation={3}
          sx={{
            p: 4,
            borderRadius: 4,
          }}
        >
          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <Heading _title="Contact Us" align="left" />

              <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                Feel free to contact us anytime.
              </Typography>

              <Typography variant="body1" sx={{ mb: 2 }}>
                📍 Address: HayatAbad Medical Complex Phase 5, Peshawar Kp
              </Typography>

              <Typography variant="body1" sx={{ mb: 2 }}>
                📞 Phone: +92 300 1234567
              </Typography>

              <Typography variant="body1" sx={{ mb: 3 }}>
                ✉️ Email: info@ptp.com
              </Typography>

              <Box
                sx={{
                  width: "100%",
                  height: 300,
                  borderRadius: 3,
                  overflow: "hidden",
                }}
              >
                <iframe
                  title="Google Map"
                  width="100%"
                  height="100%"
                  frameBorder="0"
                  style={{ border: 0 }}
                  src="https://maps.google.com/maps?q=Tangesir%20Dates%20Products&amp;t=&amp;z=13&amp;ie=UTF8&amp;iwloc=&amp;output=embed"
                  allowFullScreen
                ></iframe>
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Heading _title="Send a Message" align="left" />

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TextField fullWidth label="Your Name" variant="outlined" />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Email Address"
                    variant="outlined"
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField fullWidth label="Subject" variant="outlined" />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Message"
                    multiline
                    rows={5}
                    variant="outlined"
                  />
                </Grid>

                <Grid item xs={12}>
                  <Button variant="contained" fullWidth size="large">
                    Send Message
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </Container>
    </Box>
  );
};

export default ContactUs;
